import React from 'react';

import { ReactComponent as Icon } from 'assets/img/vectors/print-text.svg';

const PrintIcon = ({ fill, ...props }) => (
   <Icon {...props} fill={(fill ? fill : '#ffffff')} />
);

export default PrintIcon;
